import React from 'react';
import { Hammer, Home, TrendingUp } from 'lucide-react';

interface TargetCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const TargetCard: React.FC<TargetCardProps> = ({ icon, title, description }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-200">
    <div className="flex items-center justify-center w-14 h-14 bg-blue-50 rounded-xl mb-6">
      {icon}
    </div>
    <h3 className="text-xl font-bold text-gray-900 mb-4">{title}</h3>
    <p className="text-gray-600 leading-relaxed">{description}</p>
  </div>
);

export const ProTargets: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
            Un outil pensé pour les professionnels du conseil immobilier et de la rénovation.
          </h2>
          <div className="w-12 h-0.5 bg-blue-500 mb-6"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <TargetCard
            icon={<Hammer className="w-7 h-7 text-blue-600" />}
            title="Courtiers en travaux"
            description="Repartez de chaque rendez-vous avec un document scénarisé à votre nom, prêt à remettre au client. Sans avoir eu besoin de maîtriser les travaux sur le bout des doigts."
          />
          <TargetCard
            icon={<Home className="w-7 h-7 text-blue-600" />}
            title="Agents immobiliers"
            description="Un DPE F ou G inquiète votre client ? En deux minutes, vous avez une réponse chiffrée à lui donner, et une vente qui aboutit."
          />
          <TargetCard
            icon={<TrendingUp className="w-7 h-7 text-blue-600" />}
            title="Investisseurs immobiliers"
            description="Évaluez le coût réel des travaux et le retour sur investissement avant de vous engager. Pas après."
          />
        </div>
      </div>
    </section>
  );
};

export default ProTargets;
